/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DLPMatchFilter } from '../model';
// @ts-ignore
import type { DLPPolicyPattern } from '../model';
// @ts-ignore
import type { DLPValidator } from '../model';
// @ts-ignore
import type { PolicyViolationAction } from '../model';
/**
 * DLPApi - axios parameter creator
 * @export
 */
export const DLPApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} parentNode 
         * @param {string} childNode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerAddChildNode: async (parentNode: string, childNode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentNode' is not null or undefined
            assertParamExists('dLPControllerAddChildNode', 'parentNode', parentNode)
            // verify required parameter 'childNode' is not null or undefined
            assertParamExists('dLPControllerAddChildNode', 'childNode', childNode)
            const localVarPath = `/api/dlp/addChildNode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (parentNode !== undefined) {
                localVarQueryParameter['parentNode'] = parentNode;
            }

            if (childNode !== undefined) {
                localVarQueryParameter['childNode'] = childNode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerAddPolicyGroup: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerAddPolicyGroup', 'name', name)
            const localVarPath = `/api/dlp/addPolicyGroup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} regEx 
         * @param {PolicyViolationAction} action 
         * @param {boolean} delayEvaluation 
         * @param {string} [description] 
         * @param {string} [notes] 
         * @param {string} [validator] 
         * @param {number} [threshold] 
         * @param {string} [matchFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerAddPolicyPattern: async (name: string, regEx: string, action: PolicyViolationAction, delayEvaluation: boolean, description?: string, notes?: string, validator?: string, threshold?: number, matchFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerAddPolicyPattern', 'name', name)
            // verify required parameter 'regEx' is not null or undefined
            assertParamExists('dLPControllerAddPolicyPattern', 'regEx', regEx)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('dLPControllerAddPolicyPattern', 'action', action)
            // verify required parameter 'delayEvaluation' is not null or undefined
            assertParamExists('dLPControllerAddPolicyPattern', 'delayEvaluation', delayEvaluation)
            const localVarPath = `/api/dlp/addPolicyPattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (notes !== undefined) {
                localVarQueryParameter['notes'] = notes;
            }

            if (regEx !== undefined) {
                localVarQueryParameter['regEx'] = regEx;
            }

            if (validator !== undefined) {
                localVarQueryParameter['validator'] = validator;
            }

            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (delayEvaluation !== undefined) {
                localVarQueryParameter['delayEvaluation'] = delayEvaluation;
            }

            if (matchFilter !== undefined) {
                localVarQueryParameter['matchFilter'] = matchFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerDeletePolicyPattern: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerDeletePolicyPattern', 'name', name)
            const localVarPath = `/api/dlp/deletePolicyPattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerDeletePolicyPatterns: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('dLPControllerDeletePolicyPatterns', 'requestBody', requestBody)
            const localVarPath = `/api/dlp/deletePolicyPatterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [mime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerExtractTextFromMimeMessage: async (mime?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dlp/extractTextFromEmail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


            if (mime !== undefined) { 
                localVarFormParams.append('mime', mime as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetDomainPolicyPatterns: async (domain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('dLPControllerGetDomainPolicyPatterns', 'domain', domain)
            const localVarPath = `/api/dlp/getDomainPolicyPatterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetGlobalPolicyPatterns: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dlp/getGlobalPolicyPatterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetMatchFilter: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerGetMatchFilter', 'name', name)
            const localVarPath = `/api/dlp/getMatchFilter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetMatchFilters: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dlp/getMatchFilters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetPolicyPattern: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerGetPolicyPattern', 'name', name)
            const localVarPath = `/api/dlp/getPolicyPattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetPolicyPatternCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dlp/getPolicyPatternsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetPolicyPatterns: async (firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dlp/getPolicyPatterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetPolicyPatternsByName: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('dLPControllerGetPolicyPatternsByName', 'requestBody', requestBody)
            const localVarPath = `/api/dlp/getPolicyPatternsByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetReferencedDetails: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerGetReferencedDetails', 'name', name)
            const localVarPath = `/api/dlp/getReferencedDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetSkipList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dlp/getSkipList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetUserPolicyPatterns: async (email: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('dLPControllerGetUserPolicyPatterns', 'email', email)
            const localVarPath = `/api/dlp/getUserPolicyPatterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetValidator: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerGetValidator', 'name', name)
            const localVarPath = `/api/dlp/getValidator`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetValidators: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dlp/getValidators`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerIsReferenced: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerIsReferenced', 'name', name)
            const localVarPath = `/api/dlp/isReferenced`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} parentNode 
         * @param {string} childNode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerRemoveChildNode: async (parentNode: string, childNode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentNode' is not null or undefined
            assertParamExists('dLPControllerRemoveChildNode', 'parentNode', parentNode)
            // verify required parameter 'childNode' is not null or undefined
            assertParamExists('dLPControllerRemoveChildNode', 'childNode', childNode)
            const localVarPath = `/api/dlp/removeChildNode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (parentNode !== undefined) {
                localVarQueryParameter['parentNode'] = parentNode;
            }

            if (childNode !== undefined) {
                localVarQueryParameter['childNode'] = childNode;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} oldName 
         * @param {string} newName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerRenamePolicyPattern: async (oldName: string, newName: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'oldName' is not null or undefined
            assertParamExists('dLPControllerRenamePolicyPattern', 'oldName', oldName)
            // verify required parameter 'newName' is not null or undefined
            assertParamExists('dLPControllerRenamePolicyPattern', 'newName', newName)
            const localVarPath = `/api/dlp/renamePolicyPattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (oldName !== undefined) {
                localVarQueryParameter['oldName'] = oldName;
            }

            if (newName !== undefined) {
                localVarQueryParameter['newName'] = newName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} parentNode 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetChildNodes: async (parentNode: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentNode' is not null or undefined
            assertParamExists('dLPControllerSetChildNodes', 'parentNode', parentNode)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('dLPControllerSetChildNodes', 'requestBody', requestBody)
            const localVarPath = `/api/dlp/setChildNodes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (parentNode !== undefined) {
                localVarQueryParameter['parentNode'] = parentNode;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} domain 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetDomainPolicyPatterns: async (domain: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domain' is not null or undefined
            assertParamExists('dLPControllerSetDomainPolicyPatterns', 'domain', domain)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('dLPControllerSetDomainPolicyPatterns', 'requestBody', requestBody)
            const localVarPath = `/api/dlp/setDomainPolicyPatterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetGlobalPolicyPatterns: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('dLPControllerSetGlobalPolicyPatterns', 'requestBody', requestBody)
            const localVarPath = `/api/dlp/setGlobalPolicyPatterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [skipList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetSkipList: async (skipList?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/dlp/setSkipList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


            if (skipList !== undefined) { 
                localVarFormParams.append('skipList', skipList as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetUserPolicyPatterns: async (email: string, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('dLPControllerSetUserPolicyPatterns', 'email', email)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('dLPControllerSetUserPolicyPatterns', 'requestBody', requestBody)
            const localVarPath = `/api/dlp/setUserPolicyPatterns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} name 
         * @param {string} regEx 
         * @param {PolicyViolationAction} action 
         * @param {boolean} delayEvaluation 
         * @param {string} [description] 
         * @param {string} [notes] 
         * @param {string} [validator] 
         * @param {number} [threshold] 
         * @param {string} [matchFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerUpdatePolicyPattern: async (name: string, regEx: string, action: PolicyViolationAction, delayEvaluation: boolean, description?: string, notes?: string, validator?: string, threshold?: number, matchFilter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('dLPControllerUpdatePolicyPattern', 'name', name)
            // verify required parameter 'regEx' is not null or undefined
            assertParamExists('dLPControllerUpdatePolicyPattern', 'regEx', regEx)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('dLPControllerUpdatePolicyPattern', 'action', action)
            // verify required parameter 'delayEvaluation' is not null or undefined
            assertParamExists('dLPControllerUpdatePolicyPattern', 'delayEvaluation', delayEvaluation)
            const localVarPath = `/api/dlp/updatePolicyPattern`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (description !== undefined) {
                localVarQueryParameter['description'] = description;
            }

            if (notes !== undefined) {
                localVarQueryParameter['notes'] = notes;
            }

            if (regEx !== undefined) {
                localVarQueryParameter['regEx'] = regEx;
            }

            if (validator !== undefined) {
                localVarQueryParameter['validator'] = validator;
            }

            if (threshold !== undefined) {
                localVarQueryParameter['threshold'] = threshold;
            }

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (delayEvaluation !== undefined) {
                localVarQueryParameter['delayEvaluation'] = delayEvaluation;
            }

            if (matchFilter !== undefined) {
                localVarQueryParameter['matchFilter'] = matchFilter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DLPApi - functional programming interface
 * @export
 */
export const DLPApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DLPApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} parentNode 
         * @param {string} childNode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerAddChildNode(parentNode: string, childNode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerAddChildNode(parentNode, childNode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerAddChildNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerAddPolicyGroup(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLPPolicyPattern>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerAddPolicyGroup(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerAddPolicyGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {string} regEx 
         * @param {PolicyViolationAction} action 
         * @param {boolean} delayEvaluation 
         * @param {string} [description] 
         * @param {string} [notes] 
         * @param {string} [validator] 
         * @param {number} [threshold] 
         * @param {string} [matchFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerAddPolicyPattern(name: string, regEx: string, action: PolicyViolationAction, delayEvaluation: boolean, description?: string, notes?: string, validator?: string, threshold?: number, matchFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLPPolicyPattern>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerAddPolicyPattern(name, regEx, action, delayEvaluation, description, notes, validator, threshold, matchFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerAddPolicyPattern']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerDeletePolicyPattern(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLPPolicyPattern>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerDeletePolicyPattern(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerDeletePolicyPattern']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerDeletePolicyPatterns(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerDeletePolicyPatterns(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerDeletePolicyPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [mime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerExtractTextFromMimeMessage(mime?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerExtractTextFromMimeMessage(mime, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerExtractTextFromMimeMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetDomainPolicyPatterns(domain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DLPPolicyPattern>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetDomainPolicyPatterns(domain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetDomainPolicyPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetGlobalPolicyPatterns(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DLPPolicyPattern>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetGlobalPolicyPatterns(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetGlobalPolicyPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetMatchFilter(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLPMatchFilter>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetMatchFilter(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetMatchFilter']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetMatchFilters(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DLPMatchFilter>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetMatchFilters(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetMatchFilters']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetPolicyPattern(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLPPolicyPattern>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetPolicyPattern(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetPolicyPattern']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetPolicyPatternCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetPolicyPatternCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetPolicyPatternCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetPolicyPatterns(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DLPPolicyPattern>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetPolicyPatterns(firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetPolicyPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetPolicyPatternsByName(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DLPPolicyPattern>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetPolicyPatternsByName(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetPolicyPatternsByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetReferencedDetails(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetReferencedDetails(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetReferencedDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetSkipList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetSkipList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetSkipList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetUserPolicyPatterns(email: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DLPPolicyPattern>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetUserPolicyPatterns(email, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetUserPolicyPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetValidator(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLPValidator>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetValidator(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetValidator']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerGetValidators(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DLPValidator>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerGetValidators(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerGetValidators']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerIsReferenced(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerIsReferenced(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerIsReferenced']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} parentNode 
         * @param {string} childNode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerRemoveChildNode(parentNode: string, childNode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerRemoveChildNode(parentNode, childNode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerRemoveChildNode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} oldName 
         * @param {string} newName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerRenamePolicyPattern(oldName: string, newName: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerRenamePolicyPattern(oldName, newName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerRenamePolicyPattern']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} parentNode 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerSetChildNodes(parentNode: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerSetChildNodes(parentNode, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerSetChildNodes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} domain 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerSetDomainPolicyPatterns(domain: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerSetDomainPolicyPatterns(domain, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerSetDomainPolicyPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerSetGlobalPolicyPatterns(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerSetGlobalPolicyPatterns(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerSetGlobalPolicyPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {File} [skipList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerSetSkipList(skipList?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerSetSkipList(skipList, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerSetSkipList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerSetUserPolicyPatterns(email: string, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerSetUserPolicyPatterns(email, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerSetUserPolicyPatterns']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} name 
         * @param {string} regEx 
         * @param {PolicyViolationAction} action 
         * @param {boolean} delayEvaluation 
         * @param {string} [description] 
         * @param {string} [notes] 
         * @param {string} [validator] 
         * @param {number} [threshold] 
         * @param {string} [matchFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dLPControllerUpdatePolicyPattern(name: string, regEx: string, action: PolicyViolationAction, delayEvaluation: boolean, description?: string, notes?: string, validator?: string, threshold?: number, matchFilter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DLPPolicyPattern>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dLPControllerUpdatePolicyPattern(name, regEx, action, delayEvaluation, description, notes, validator, threshold, matchFilter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DLPApi.dLPControllerUpdatePolicyPattern']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DLPApi - factory interface
 * @export
 */
export const DLPApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DLPApiFp(configuration)
    return {
        /**
         * 
         * @param {string} parentNode 
         * @param {string} childNode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerAddChildNode(parentNode: string, childNode: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.dLPControllerAddChildNode(parentNode, childNode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerAddPolicyGroup(name: string, options?: any): AxiosPromise<DLPPolicyPattern> {
            return localVarFp.dLPControllerAddPolicyGroup(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {string} regEx 
         * @param {PolicyViolationAction} action 
         * @param {boolean} delayEvaluation 
         * @param {string} [description] 
         * @param {string} [notes] 
         * @param {string} [validator] 
         * @param {number} [threshold] 
         * @param {string} [matchFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerAddPolicyPattern(name: string, regEx: string, action: PolicyViolationAction, delayEvaluation: boolean, description?: string, notes?: string, validator?: string, threshold?: number, matchFilter?: string, options?: any): AxiosPromise<DLPPolicyPattern> {
            return localVarFp.dLPControllerAddPolicyPattern(name, regEx, action, delayEvaluation, description, notes, validator, threshold, matchFilter, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerDeletePolicyPattern(name: string, options?: any): AxiosPromise<DLPPolicyPattern> {
            return localVarFp.dLPControllerDeletePolicyPattern(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerDeletePolicyPatterns(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.dLPControllerDeletePolicyPatterns(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [mime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerExtractTextFromMimeMessage(mime?: File, options?: any): AxiosPromise<string> {
            return localVarFp.dLPControllerExtractTextFromMimeMessage(mime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} domain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetDomainPolicyPatterns(domain: string, options?: any): AxiosPromise<Array<DLPPolicyPattern>> {
            return localVarFp.dLPControllerGetDomainPolicyPatterns(domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetGlobalPolicyPatterns(options?: any): AxiosPromise<Array<DLPPolicyPattern>> {
            return localVarFp.dLPControllerGetGlobalPolicyPatterns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetMatchFilter(name: string, options?: any): AxiosPromise<DLPMatchFilter> {
            return localVarFp.dLPControllerGetMatchFilter(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetMatchFilters(options?: any): AxiosPromise<Array<DLPMatchFilter>> {
            return localVarFp.dLPControllerGetMatchFilters(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetPolicyPattern(name: string, options?: any): AxiosPromise<DLPPolicyPattern> {
            return localVarFp.dLPControllerGetPolicyPattern(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetPolicyPatternCount(options?: any): AxiosPromise<number> {
            return localVarFp.dLPControllerGetPolicyPatternCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetPolicyPatterns(firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<DLPPolicyPattern>> {
            return localVarFp.dLPControllerGetPolicyPatterns(firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetPolicyPatternsByName(requestBody: Array<string>, options?: any): AxiosPromise<Array<DLPPolicyPattern>> {
            return localVarFp.dLPControllerGetPolicyPatternsByName(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetReferencedDetails(name: string, options?: any): AxiosPromise<Array<string>> {
            return localVarFp.dLPControllerGetReferencedDetails(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetSkipList(options?: any): AxiosPromise<string> {
            return localVarFp.dLPControllerGetSkipList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetUserPolicyPatterns(email: string, options?: any): AxiosPromise<Array<DLPPolicyPattern>> {
            return localVarFp.dLPControllerGetUserPolicyPatterns(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetValidator(name: string, options?: any): AxiosPromise<DLPValidator> {
            return localVarFp.dLPControllerGetValidator(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerGetValidators(options?: any): AxiosPromise<Array<DLPValidator>> {
            return localVarFp.dLPControllerGetValidators(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerIsReferenced(name: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.dLPControllerIsReferenced(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} parentNode 
         * @param {string} childNode 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerRemoveChildNode(parentNode: string, childNode: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.dLPControllerRemoveChildNode(parentNode, childNode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} oldName 
         * @param {string} newName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerRenamePolicyPattern(oldName: string, newName: string, options?: any): AxiosPromise<void> {
            return localVarFp.dLPControllerRenamePolicyPattern(oldName, newName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} parentNode 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetChildNodes(parentNode: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.dLPControllerSetChildNodes(parentNode, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} domain 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetDomainPolicyPatterns(domain: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.dLPControllerSetDomainPolicyPatterns(domain, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetGlobalPolicyPatterns(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.dLPControllerSetGlobalPolicyPatterns(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [skipList] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetSkipList(skipList?: File, options?: any): AxiosPromise<void> {
            return localVarFp.dLPControllerSetSkipList(skipList, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerSetUserPolicyPatterns(email: string, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.dLPControllerSetUserPolicyPatterns(email, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} name 
         * @param {string} regEx 
         * @param {PolicyViolationAction} action 
         * @param {boolean} delayEvaluation 
         * @param {string} [description] 
         * @param {string} [notes] 
         * @param {string} [validator] 
         * @param {number} [threshold] 
         * @param {string} [matchFilter] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dLPControllerUpdatePolicyPattern(name: string, regEx: string, action: PolicyViolationAction, delayEvaluation: boolean, description?: string, notes?: string, validator?: string, threshold?: number, matchFilter?: string, options?: any): AxiosPromise<DLPPolicyPattern> {
            return localVarFp.dLPControllerUpdatePolicyPattern(name, regEx, action, delayEvaluation, description, notes, validator, threshold, matchFilter, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DLPApi - object-oriented interface
 * @export
 * @class DLPApi
 * @extends {BaseAPI}
 */
export class DLPApi extends BaseAPI {
    /**
     * 
     * @param {string} parentNode 
     * @param {string} childNode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerAddChildNode(parentNode: string, childNode: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerAddChildNode(parentNode, childNode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerAddPolicyGroup(name: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerAddPolicyGroup(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {string} regEx 
     * @param {PolicyViolationAction} action 
     * @param {boolean} delayEvaluation 
     * @param {string} [description] 
     * @param {string} [notes] 
     * @param {string} [validator] 
     * @param {number} [threshold] 
     * @param {string} [matchFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerAddPolicyPattern(name: string, regEx: string, action: PolicyViolationAction, delayEvaluation: boolean, description?: string, notes?: string, validator?: string, threshold?: number, matchFilter?: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerAddPolicyPattern(name, regEx, action, delayEvaluation, description, notes, validator, threshold, matchFilter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerDeletePolicyPattern(name: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerDeletePolicyPattern(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerDeletePolicyPatterns(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerDeletePolicyPatterns(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [mime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerExtractTextFromMimeMessage(mime?: File, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerExtractTextFromMimeMessage(mime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} domain 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetDomainPolicyPatterns(domain: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetDomainPolicyPatterns(domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetGlobalPolicyPatterns(options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetGlobalPolicyPatterns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetMatchFilter(name: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetMatchFilter(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetMatchFilters(options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetMatchFilters(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetPolicyPattern(name: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetPolicyPattern(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetPolicyPatternCount(options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetPolicyPatternCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetPolicyPatterns(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetPolicyPatterns(firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetPolicyPatternsByName(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetPolicyPatternsByName(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetReferencedDetails(name: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetReferencedDetails(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetSkipList(options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetSkipList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetUserPolicyPatterns(email: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetUserPolicyPatterns(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetValidator(name: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetValidator(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerGetValidators(options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerGetValidators(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerIsReferenced(name: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerIsReferenced(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} parentNode 
     * @param {string} childNode 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerRemoveChildNode(parentNode: string, childNode: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerRemoveChildNode(parentNode, childNode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} oldName 
     * @param {string} newName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerRenamePolicyPattern(oldName: string, newName: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerRenamePolicyPattern(oldName, newName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} parentNode 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerSetChildNodes(parentNode: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerSetChildNodes(parentNode, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} domain 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerSetDomainPolicyPatterns(domain: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerSetDomainPolicyPatterns(domain, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerSetGlobalPolicyPatterns(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerSetGlobalPolicyPatterns(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [skipList] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerSetSkipList(skipList?: File, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerSetSkipList(skipList, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerSetUserPolicyPatterns(email: string, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerSetUserPolicyPatterns(email, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} name 
     * @param {string} regEx 
     * @param {PolicyViolationAction} action 
     * @param {boolean} delayEvaluation 
     * @param {string} [description] 
     * @param {string} [notes] 
     * @param {string} [validator] 
     * @param {number} [threshold] 
     * @param {string} [matchFilter] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DLPApi
     */
    public dLPControllerUpdatePolicyPattern(name: string, regEx: string, action: PolicyViolationAction, delayEvaluation: boolean, description?: string, notes?: string, validator?: string, threshold?: number, matchFilter?: string, options?: RawAxiosRequestConfig) {
        return DLPApiFp(this.configuration).dLPControllerUpdatePolicyPattern(name, regEx, action, delayEvaluation, description, notes, validator, threshold, matchFilter, options).then((request) => request(this.axios, this.basePath));
    }
}

